import { FC, ReactNode } from 'react'
import { SideoverState, TagState } from '@/states'
import { useTags } from '@/hooks'
import { TagsValidation, Translation } from '@/helpers'
import { CheckIcon, InformationCircleIcon } from '@heroicons/react/16/solid'

const Tags: FC = (): ReactNode => {
    useTags()

    const { Form, Loading, Errors, SetState, Open } = SideoverState()
    const { Tags } = TagState()

    const validation: ValidationFunctionObjectReturnTypes = TagsValidation()

    const HandleClick = (id: string) => {
        if (Open && !Loading) {
            const form = structuredClone(Form)
            const errors = structuredClone(Errors)

            const isIdAdded = form?.Tags?.includes(id)

            if (isIdAdded) form?.Tags?.splice(form?.Tags?.indexOf(id), 1)
            else form?.Tags?.push(id)

            errors.Tags = true

            SetState({
                Form: form,
                Errors: errors
            })
        }
    }

    return (
        <div className='select-none sm:col-span-2' style={Loading || !Tags || !Form?.Tags ? { opacity: '0.75', pointerEvents: 'none' } : { opacity: '1', pointerEvents: 'auto' }}>
            <label htmlFor='tags' className='select-none block mb-1 text-[13px] font-medium text-[#97999b]'>
                {Translation('tags')}
            </label>

            <div id='tags' className='gap-1.5 w-full flex rounded-md text-sm items-start justify-start flex-wrap'>
                {
                    Tags?.length > 0 && Tags?.map((tag: TagInterface) => {
                        const is_tag_added = Form?.Tags?.includes(tag._id)

                        return (
                            <span onClick={() => HandleClick(tag._id)} key={tag._id} className='flex capitalize items-center text-[13px] p-1 px-1.5 bg-[#5b5b5b] text-[#CECECE] rounded-md hover:opacity-90 transition-all duration-500 ease-in-out cursor-pointer'>
                                {tag?.Name?.replace(',', '')}

                                <div className={`flex justify-center items-center w-auto ${is_tag_added ? 'visible' : 'invisible'}`}>
                                    <CheckIcon className='w-4 ml-1 h-4 text-[#CDD5DA]' />
                                </div>
                            </span>
                        )
                    })
                }

                {
                    Tags?.length === 0 && (
                        <p className='bg-[#ffffff10] flex-col rounded-md w-full h-16 flex items-center justify-center text-[13px] font-medium text-[#97999b]'>
                            <InformationCircleIcon className='w-3 h-3 mb-1' />

                            Not tags found!
                        </p>
                    )
                }
            </div>

            <p style={validation?.error && Errors?.Tags ? { opacity: '1', marginTop: '4px' } : { opacity: '0', marginTop: '4px' }} className='text-xs h-6 ml-[2px] text-red-500 transition-all duration-500 ease-in-out'>
                {validation?.message}
            </p>
        </div>
    )
}

export default Tags
